import { Switch } from '@chakra-ui/react';
import { t } from 'i18next';

interface SwitchColorModeBarProps {
  isColorModeOnEditable: boolean;
  onColorModeSwitchChanged: () => void;
}

const SwitchColorModeBar = ({
  isColorModeOnEditable,
  onColorModeSwitchChanged
}: SwitchColorModeBarProps) => {
  return (
    <div className="rounded-[12px] flex items-center px-[20px] py-[12px] bg-surface-light dark:bg-surface-dark">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-[6px]">
          <img src="/assets/icons/color.mode.png" className="w-[16px] h-[16px]" alt="color mode" />
          <p className="text-main-light-2 dark:text-main-dark-2 text-[14px] font-medium leading-none">
            {t('photoCardPage.showColorMode')}
          </p>
        </div>
        <Switch
          size="sm"
          colorScheme="primary"
          isChecked={isColorModeOnEditable}
          onChange={onColorModeSwitchChanged}
          sx={{
            '.chakra-switch__track': {
              _checked: {
                bg: '#5C3DFA'
              },
              _dark: {
                bg: '#303030',
                _checked: {
                  bg: '#5C3DFA'
                }
              }
            },
            '.chakra-switch__thumb': {
              _dark: {
                bg: '#ffffff',
                _checked: {
                  bg: '#ffffff'
                }
              }
            }
          }}
        />
      </div>
    </div>
  );
};

export default SwitchColorModeBar;
